import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  employeeCourses: {
    // ===== Mitarbeiter-Kurse (User Ansicht) =====
    fetchCourses(params = {}) {
      const url = buildUrl("employee-courses")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },

    fetchCourse(id) {
      const url = buildUrl(`employee-courses/${id}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    register(courseId) {
      const url = buildUrl(`employee-courses/${courseId}/register`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },

    unregister(courseId) {
      const url = buildUrl(`employee-courses/${courseId}/unregister`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },

    fetchActiveFormats() {
      const url = buildUrl("employee-courses/formats")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // ===== Admin & Management Ansicht =====
    admin: {
      fetchCourses(params = {}) {
        const url = buildUrl("employee-courses/admin")
        return axios.get(url, buildOptions({ params })).then((res) => res.data)
      },

      createCourse(data) {
        const url = buildUrl("employee-courses/admin")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },

      updateCourse(id, data) {
        const url = buildUrl(`employee-courses/admin/${id}`)
        return axios.put(url, data, buildOptions()).then((res) => res.data)
      },

      deleteCourse(id) {
        const url = buildUrl(`employee-courses/admin/${id}`)
        return axios.delete(url, buildOptions()).then((res) => res.data)
      },

      fetchRegistrations(courseId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/registrations`)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      fetchUserDetails(userId) {
        const url = buildUrl(`employee-courses/admin/user/${userId}`)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      manualRegister(courseId, userId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/manual-register`)
        return axios.post(url, { userId }, buildOptions()).then((res) => res.data)
      },

      cancelRegistration(courseId, registrationId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/registrations/${registrationId}/cancel`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },

      // Course Formats management
      fetchFormats() {
        const url = buildUrl("employee-courses/admin/formats")
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      createFormat(data) {
        const url = buildUrl("employee-courses/admin/formats")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },

      updateFormat(id, data) {
        const url = buildUrl(`employee-courses/admin/formats/${id}`)
        return axios.put(url, data, buildOptions()).then((res) => res.data)
      },
    },
  },
}
